// extracted by mini-css-extract-plugin
module.exports = {"tablet":"768","desktop":"1024","md":"768","lg":"1024","tile-list":"tile-list_tile-list__cz_iP"};